import React from "react";
import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

interface FlexContainerProps {
  direction: "row" | "column";
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | " space-evenly"
    | "start"
    | "end";
  className?: string;
  children?: React.ReactNode;
}

export const FlexContainer = ({
  direction,
  children,
  justifyContent,
  className = "",
}: FlexContainerProps) => {
  const style = useStyles({ direction: direction, justifyContent: justifyContent });
  return <div className={clsx(className, style.root)}>{children}</div>;
};

const useStyles = makeStyles<Theme, FlexContainerProps>(() => ({
  root: {
    flexDirection: (props) => props.direction,
    justifyContent: (props) => props.justifyContent,
    display: "flex",
  },
}));
